import moment from 'moment-timezone';
import { convertEstDatetimeToPst } from 'shared/helpers/FormatDatetime';

export const validateStartTime = (value, formValues) => {
  let error;
  if (formValues.publishAtDate && !value) {
    error = 'Please enter a Start Time.';
  }
  return error;
};

export const validateSendTime = (value, formValues) => {
  let error;

  const MINIMUM_SEND_DELAY = 1;
  const earliestPSTSendDateTime = moment
    .tz('America/Los_Angeles')
    .add(MINIMUM_SEND_DELAY, 'minutes')
    .format('YYYY-MM-DD HH:mm');

  const pstConvertedDate = convertEstDatetimeToPst(
    formValues.sendDate,
    formValues.sendTime
  );

  const regEx = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
  if (formValues.sendTime && !value) {
    error = 'Please enter a valid send time.';
  } else if (!regEx.test(formValues.sendTime)) {
    error = 'Please use HH:MM format for the time.';
  }
  if (
    pstConvertedDate &&
    pstConvertedDate.isBefore(earliestPSTSendDateTime, 'minute')
  ) {
    error = 'Please enter a send time in the future.';
  }
  return error;
};

export const validateEndTime = (value, formValues) => {
  let error;
  if (formValues.removeAtDate && !value) {
    error = 'Please enter an End Time.';
  }
  return error;
};
